/**
 * Signup page — email + password + company, posts to /api/auth/signup.
 */
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AuthAPI, auth, errorMessage } from '../services/api';

export default function Signup() {
    const navigate = useNavigate();
    const [form, setForm] = useState({ email: '', password: '', confirm: '', company_name: '' });
    const [error, setError] = useState(null);
    const [busy, setBusy]   = useState(false);

    function update(field) {
        return (e) => setForm({ ...form, [field]: e.target.value });
    }

    function validate() {
        if (!form.email.includes('@'))         return 'Enter a valid email.';
        if (form.password.length < 8)          return 'Password must be at least 8 characters.';
        if (form.password !== form.confirm)    return 'Passwords do not match.';
        return null;
    }

    async function handleSubmit(e) {
        e.preventDefault();
        const v = validate();
        if (v) { setError(v); return; }

        try {
            setBusy(true);
            setError(null);
            const data = await AuthAPI.signup({
                email: form.email,
                password: form.password,
                company_name: form.company_name || null,
            });
            auth.set(data);
            navigate('/', { replace: true });
        } catch (err) {
            setError(errorMessage(err));
        } finally {
            setBusy(false);
        }
    }

    return (
        <div className="max-w-md mx-auto mt-10 bg-white border border-gray-200 rounded-lg p-6">
            <h1 className="text-xl font-semibold text-gray-900">Create your account</h1>
            <p className="mt-1 text-sm text-gray-500">Free tier — 50 leads / month, no card required.</p>

            <form className="mt-6 space-y-4" onSubmit={handleSubmit} noValidate>
                <div>
                    <label className="block text-sm font-medium text-gray-700">Work email</label>
                    <input
                        type="email"
                        autoComplete="email"
                        value={form.email}
                        onChange={update('email')}
                        className="mt-1 w-full border border-gray-300 rounded p-2 focus:outline-none focus:ring-2 focus:ring-brand-500"
                    />
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700">Company (optional)</label>
                    <input
                        type="text"
                        value={form.company_name}
                        onChange={update('company_name')}
                        className="mt-1 w-full border border-gray-300 rounded p-2 focus:outline-none focus:ring-2 focus:ring-brand-500"
                    />
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700">Password</label>
                    <input
                        type="password"
                        autoComplete="new-password"
                        value={form.password}
                        onChange={update('password')}
                        className="mt-1 w-full border border-gray-300 rounded p-2 focus:outline-none focus:ring-2 focus:ring-brand-500"
                    />
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700">Confirm password</label>
                    <input
                        type="password"
                        autoComplete="new-password"
                        value={form.confirm}
                        onChange={update('confirm')}
                        className="mt-1 w-full border border-gray-300 rounded p-2 focus:outline-none focus:ring-2 focus:ring-brand-500"
                    />
                </div>

                {error && <div className="text-sm text-red-600">{error}</div>}

                <button
                    type="submit"
                    disabled={busy}
                    className="w-full rounded bg-brand-500 text-white font-medium py-2 hover:bg-brand-600 disabled:opacity-50"
                >
                    {busy ? 'Creating account…' : 'Create account'}
                </button>
            </form>

            <p className="mt-4 text-sm text-gray-600">
                Already have an account? <Link to="/login" className="text-brand-600 underline">Log in</Link>
            </p>
        </div>
    );
}
